'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' });

var ControlPoint = function ControlPoint(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ControlPoint = (0, _pure2.default)(ControlPoint);
ControlPoint.muiName = 'SvgIcon';

exports.default = ControlPoint;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/ControlPoint.js
// module id = 2280
// module chunks = 0